module.exports = __webpack_public_path__ + "img/20.problem_mirro.de2514a0.svg";